import React from 'react'
import By from '../By/By'
import './Slider.css'

const Slider = ({testimonial, by, position, image}) => {
    return (
        <div id="container" className="slider">
            <p>"{testimonial}"</p>
            <By name={by} position={position} image={image} />
        </div>
    )
}

export default Slider
